import {Component, Input} from '@angular/core';

import {HelpLoginComponent} from "./components/help-login/help-login.component";
import {HelpLogoutComponent} from "./components/help-logout/help-logout.component";
import {HelpRegisterComponent} from "./components/help-register/help-register.component";
import {HelpPasswordResetComponent} from "./components/help-password-reset/help-password-reset.component";
import {HelpAccountSecurityComponent} from "./components/help-account-security/help-account-security.component";
import {HelpReportAbuseComponent} from "./components/help-report-abuse/help-report-abuse.component";

@Component({
  selector: 'nz-login-security',
  standalone: true,
  imports: [
    HelpLoginComponent,
    HelpLogoutComponent,
    HelpRegisterComponent,
    HelpPasswordResetComponent,
    HelpAccountSecurityComponent,
    HelpReportAbuseComponent
  ],
  templateUrl: './login-security.component.html',
  styleUrl: './login-security.component.scss'
})
export class LoginSecurityComponent {
  @Input() subsectionId?: number;
}
